import { Expose, plainToInstance } from 'class-transformer';

export class AuthModel {
  @Expose() phone?: string;

  @Expose({ name: 'auth_token' }) authToken?: string;

  @Expose({ name: 'refresh_token' }) refreshToken?: string;

  @Expose() token?: string;

  @Expose({ name: 'access_token' }) accessToken?: string;
}

export const toAuthModel = (dto: unknown): AuthModel =>
  plainToInstance(AuthModel, dto, { excludeExtraneousValues: true });
